import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useMemo,
  useState,
} from 'react';

import UserItemDto from '../models/dto/user-item.dto';
import { modeType } from '@models/mode';

interface UserMutationContextData {
  stepIndex: number;
  setStepIndex: Dispatch<SetStateAction<number>>;
  payload: UserItemDto | undefined;
  setPayload: Dispatch<SetStateAction<UserItemDto | undefined>>;
  mode: modeType;
  setMode: Dispatch<SetStateAction<modeType>>;
  isDirty: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

export const UserMutationContext = createContext<
  UserMutationContextData | undefined
>(undefined);

const UserMutationProvider = ({ children }: { children: ReactNode }) => {
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [payload, setPayload] = useState<UserItemDto>();
  const [mode, setMode] = useState<modeType>('create');
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      stepIndex,
      setStepIndex,
      payload,
      setPayload,
      mode,
      setMode,
      isDirty,
      setIsDirty,
    }),
    [stepIndex, payload, mode, isDirty],
  );

  return (
    <UserMutationContext.Provider value={value}>
      {children}
    </UserMutationContext.Provider>
  );
};

export default UserMutationProvider;
